import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import "./index.css";

// Dynamic manifest: professor vs student
const isStudentRoute = window.location.pathname.startsWith("/aluno");
const manifestLink = document.querySelector('link[rel="manifest"]');
if (manifestLink) {
  manifestLink.setAttribute("href", isStudentRoute ? "/manifest.json" : "/manifest-professor.json");
}

// Auto-reload when a new service worker is available (new deploy)
registerSW({
  onNeedRefresh() {
    window.location.reload();
  },
  onOfflineReady() {
    console.log("[PWA] Offline ready");
  },
});

createRoot(document.getElementById("root")!).render(<App />);
